export default {
  error_messages: {
    orders_disabled: 'Não é possível encomendar aqui de momento',
  },
};
